enum EWidgetPerformanceTableRowType {
  FIRST = 'first',
  LAST = 'last',
  ROW = 'row',
}

export default EWidgetPerformanceTableRowType;
